__turbopack_context__.v({
  "PrivacyProvideCouponSheet": "PrivacySheet-module-scss-module__nAnkbG__PrivacyProvideCouponSheet",
  "PrivacySheet": "PrivacySheet-module-scss-module__nAnkbG__PrivacySheet",
  "container": "PrivacySheet-module-scss-module__nAnkbG__container",
  "description": "PrivacySheet-module-scss-module__nAnkbG__description",
  "descriptionContainer": "PrivacySheet-module-scss-module__nAnkbG__descriptionContainer",
  "descriptionText": "PrivacySheet-module-scss-module__nAnkbG__descriptionText",
  "link": "PrivacySheet-module-scss-module__nAnkbG__link",
  "nomal": "PrivacySheet-module-scss-module__nAnkbG__nomal",
  "strong": "PrivacySheet-module-scss-module__nAnkbG__strong",
  "table": "PrivacySheet-module-scss-module__nAnkbG__table",
  "tableCell": "PrivacySheet-module-scss-module__nAnkbG__tableCell",
  "tableStrongCell": "PrivacySheet-module-scss-module__nAnkbG__tableStrongCell",
  "tdCell": "PrivacySheet-module-scss-module__nAnkbG__tdCell",
  "wrap": "PrivacySheet-module-scss-module__nAnkbG__wrap",
});
